var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order.quantity > 1 && _vm.order.isDstv)?_c('v-avatar',{staticClass:"primary ml-1",attrs:{"left":"","size":25}},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.order.quantity))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }